import { actionTypes } from "../constants/site";

const actions = {
  setLoadingMsg: (msg) => ({
    type: actionTypes.SET_LOADING_MSG,
    payload: { msg },
  }),
  setModal: (modal) => ({
    type: actionTypes.SET_MODAL,
    payload: { modal },
  }),
  closeModal: () => ({
    type: actionTypes.CLOSE_MODAL,
  }),
};

export { actions };
